// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/badge/badge.component.scss
// module id = 136
// module chunks = 0